import { useIntl } from 'react-intl';

export const useRevertCohortDefinitionModalString = () => {
  const intl = useIntl();

  const messages = {
    title: intl.formatMessage({
      id: 'projects.cohortBuilderPage.header.undoButton', // Reuse Undo button label or create 'projects.cohortBuilderPage.revertModal.title'
    }),
    errorTitle: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.errorTitle',
    }),
    errorMessage: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.errorMessage', // "Something went wrong..."
    }),
    retryBtn: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.retryBtn',
    }),
    successTitle: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.successTitle',
    }),
    successText: intl.formatMessage({
      id: 'projects.cohortBuilderPage.revertModal.successText',
      defaultMessage: 'Cohort definition has been reverted to the last saved state.',
    }),
    loadingTitle: intl.formatMessage({
      id: 'projects.cohortBuilderPage.revertModal.loadingTitle',
      defaultMessage: 'Reverting...',
    }),
    loadingText: intl.formatMessage({
      id: 'projects.cohortBuilderPage.revertModal.loadingText',
      defaultMessage: 'Please wait while we revert your changes.',
    }),
  };

  return { messages };
};
